export default __webpack_public_path__ + "static/media/logo-mobile.9a46cf8f.png";